export default __webpack_public_path__ + "static/media/box.4194ab95.svg";